/* eslint-disable class-methods-use-this */
import DirectoryService from './DirectoryService';

class MicrosoftGccHighDirectoryService implements DirectoryService {
  readonly name = 'Microsoft GCC High';

  // We do not have any restrictions on changing RSVP for Microsoft Gcc High.
  canChangeRsvp = () => true;

  showEmployeeDirectoryIntegrationErrorInOrgCalendarPreference = () => false;
}

export default MicrosoftGccHighDirectoryService;
